<template>
	<transition 
			appear
			:appear-active-class="$_recruit_stylePageAnimation()">
		<template v-if="initialized_">
			<v-container 
					class="customVContainer fluid"
					:style="$_recruit_stylePageContainerStyle()"
					fluid>
				<!-- steps -->
				<template v-if="$_recruit_paramsRecruitmentId && $_recruit_paramsScheduleId">
					<template v-if="$_recruit_getRecruitmentByRecruitmentIdAndScheduleId()">
						<recruit-step-tab-layout
							:schedule="$_recruit_schedule()"

							:contents="$_recruit_contents()"
							:inits="$_recruit_inits()" />
					</template>
				</template>
				<!-- schedules -->
				<template v-else-if="$_recruit_paramsRecruitmentId">
					<template v-if="$_recruit_getRecruitmentByRecruitmentId()">
						<recruit-schedule-sheet-layout
							:recruitment="$_recruit_recruitment()"

							:contents="$_recruit_contents()"
							:inits="$_recruit_inits()" />
					</template>
				</template>
				<!-- Page Title -->
				<template v-else>
					<page-title-layout
							:inits="$_recruit_inits()" />
				</template>
			</v-container>
		</template>
		<template v-else>
			<v-row	class="customVRow">
				<v-col cols="12" class="center">
					<progress-circular />
				</v-col>
			</v-row>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'Recruit',
		data() {
			return {
				pageName_: 'recruit',
				pageType_: 'recruit',

				initialized_: false,

				recruitRecruitment_: {},
				recruitSchedule_: {}
			}
		},
		computed: {
			// route
			$_recruit_routeName() {
				const self_ = this;
				const route_ = self_.$route
				return route_.name
			},
			// params
			$_recruit_params() {
				const self_ = this;
				const route_ = self_.$route
				return route_.params
			},
			$_recruit_paramsRecruitmentId() {
				const self_ = this;
				const params_ = self_.$_recruit_params;
				if(self_.isFalse(params_)) { return null }
				return params_.recruitmentId
			},
			$_recruit_paramsScheduleId() {
				const self_ = this;
				const params_ = self_.$_recruit_params;
				if(self_.isFalse(params_)) { return null }
				return params_.scheduleId
			},
			// current user
			$_recruit_currentUser() {
				const self_ = this;
				return self_.getCurrentUser()
			},
			// state
			$_recruit_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			$_recruit_statePageIsInitialized() {
				const self_ = this;
				const initialized_ = self_.getPageState('isInitialized')
				return initialized_[self_.pageName_]
			},
			$_recruit_stateUserRecruit() {
				const self_ = this;
				return self_.getUserState('recruit')
			},
			// recruit
			$_recruit_recruitment() {
				const self_ = this;
				return () => {
					return self_.recruitRecruitment_
				}
			},
			$_recruit_schedule() {
				const self_ = this;
				return () => {
					return self_.recruitSchedule_
				}				
			},
			// contents / inits
			$_recruit_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getPageContents(self_.pageName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_recruit_inits() {
				const self_ = this;
				return () => {
					return self_.getPageInits(self_.pageName_)
				}
			},
			// info
			$_recruit_infoContact() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.$_recruit_inits(), 'contact')
			},
			// style
			$_recruit_stylePage() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.$_recruit_inits())) { return null }
					return self_.getInitsStyleVal(self_.$_recruit_inits(), 'page')
				}
			},
			$_recruit_stylePageAnimation() {
				const self_ = this;
				return () => {
					const page_ = self_.$_recruit_stylePage()
					if(self_.isFalse(page_)) { return null }
					return self_.getStylesVal(page_.animation)
				}
			},
			$_recruit_stylePageContainer() {
				const self_ = this;
				if(self_.isEmpty(self_.$_recruit_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_recruit_inits(), 'pageContainer')
			},
			$_recruit_stylePageContainerStyle() {
				const self_ = this;
				return () => {
					const page_ = self_.$_recruit_stylePageContainer;
					if(self_.isFalse(page_)) { return null }
					return self_.getStylesVal(page_.style)
				}
			}
		},
		watch: {
			$route() { 
				const self_ = this;
				if(self_.$_recruit_routeName == 'recruit') { self_.$_recruit_updateRoute() }
			}
		},
		created() {
			const self_ = this;
			// life cycle
			self_.createdPage(self_.pageName_)

			self_.$_recruit_setPageState()

			if(self_.$_recruit_statePageIsInitialized) { 
				self_.initialized_ = true;
			} else {
				self_.$_recruit_initialize()
			}
		},
		beforeMount() {
			const self_ = this;
			self_.beforeMountPage(self_.pageName_)

			self_.$_recruit_updateRoute()
		},
		beforeDestroy() {
			const self_ = this;
			self_.beforeDestroyPage(self_.pageName_)
		},
		methods: {
			$_recruit_setPageState() {
				const self_ = this;

				self_.setPageState('name', self_.pageName_)
				self_.setPageState('type', self_.pageType_)
			},
			$_recruit_initialize() {
				const self_ = this;

				Promise.resolve().then(() => {
					return self_.initializePage(self_.pageName_, self_.pageType_)
				}).then(() => {
					self_.initialized_ = true;
				}).catch(error => {
/* error */			self_.logError('Error', '$_recruit_initialize()', error)
				})
			},
			$_recruit_getRecruitmentByRecruitmentId() {
				const self_ = this;

				if(!self_.isEmpty(self_.recruitRecruitment_)) { return true }

				Promise.resolve().then(() => {
					return self_.getRecruitmentByRecruitmentId(self_.$_recruit_paramsRecruitmentId)
				}).then(result => {
					self_.recruitRecruitment_ = result;
					return true
				}).catch(error => {
/* error */			self_.logError('Error', '$_recruit_getRecruitmentByRecruitmentId()', error)

					return false
				})
			},
			$_recruit_getRecruitmentByRecruitmentIdAndScheduleId() {
				const self_ = this;

				if(!self_.isEmpty(self_.recruitSchedule_)) { return true }

				Promise.resolve().then(() => {
					return self_.getRecruitmentByRecruitmentIdAndScheduleId(self_.$_recruit_paramsRecruitmentId, self_.$_recruit_paramsScheduleId)
				}).then(result => {
					self_.recruitSchedule_ = result;
					return true
				}).catch(error => {
/* error */			self_.logError('Error', '$_recruit_getRecruitmentByRecruitmentIdAndScheduleId()', error)

					return false
				})
			},
			$_recruit_updateRoute() {
				const self_ = this;
				const router_ = self_.$router;

				self_.recruitRecruitment_ = {}
				self_.recruitSchedule_ = {}

				// recruit schedule
				if(self_.$_recruit_paramsRecruitmentId && self_.$_recruit_paramsScheduleId) {
					router_.replace({
						name: 'recruitSchedule',
						params: {
							recruitmentId: self_.$_recruit_paramsRecruitmentId,
							scheduleId: self_.$_recruit_paramsScheduleId
						}
					})
				}
				// recruit recruitment
				else if(self_.$_recruit_paramsRecruitmentId) {
					router_.replace({
						name: 'recruitRecruitment',
						params: {
							recruitmentId: self_.$_recruit_paramsRecruitmentId
						}
					})
				}
			}
		}
	}
</script>

<style scoped>
</style>